<template>
    <div id="product_btn" 
        class="product-btn map-top-item"
        :class="{ 
            'active': is_user_select_products, 
            'open': is_open_product_setting_dialog,
        }"    
    >
        <div v-if="show_product_btn_notice"
            class="btn-notice__content"
        >
            圖資的調整請按這裡
            <button class="btn-notice__btn"
                @click="not_show_product_btn_notice"
            >
                知道了
            </button>
        </div>

        <div
            class="product-btn__container"
            @click.stop="open_product_setting_dialog"
        >
            <v-icon class="product-btn__icon">
                icon-selected-data-setting
            </v-icon>

            <span 
                v-show="!this.is_open_product_setting_dialog"
                class="product-btn__text"
            >
                {{ $t('__product_setting.title') }}
            </span>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {

        name: 'ProductBtn',

        props: ['name', 'title'],
        
        data() {
            return {
                is_open_product_setting_dialog: false,
                show_product_btn_notice: true
            }
        },

        mounted() {
            this.show_product_btn_notice = !localStorage.getItem('show_product_btn_notice');
        },

        computed: {
            ...mapState({
                selected_products: state => state.emap.selected_products,
            }),

            ...mapState([
                'client_name',
            ]),

            ...mapState('emap-monitor', [
                'monitor_map',
                'is_monitor_open_emap'
            ]),

            is_user_select_products() {
                return this.is_monitor_open_emap ? this.monitor_map.length > 0 : this.selected_products.length > 0
            }
        },

        methods: {
            open_product_setting_dialog() {
                this.is_open_product_setting_dialog = !this.is_open_product_setting_dialog
                this.$emit('open-product-setting-dialog', this.is_open_product_setting_dialog)

                this.not_show_product_btn_notice();
            },

            not_show_product_btn_notice() {
                this.show_product_btn_notice = false;
                localStorage.setItem('show_product_btn_notice', 'show once');
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../../css/mixin.scss';

    .product-btn {
        position: relative;
        margin: 0.6rem;
        margin-top: -0.01rem;

        width: 2rem;
        height: 2rem;
        padding: 0.25rem;
        border-radius: 1rem;
        background-color: var(--base-gray);

        &__container {
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: bold;
            cursor: pointer;
            background-color: transparent;
            color: white;
        }

        &__icon {
            height: 24px;
            width: 24px;
            background-size: 100%;
            color: var(--grey-pipe);
        }

        &__text {
            position: absolute;
            right: 2rem;
            margin-right: 0.5rem;
            padding: 0.4em 0.8em;
            font-size: 0.8rem;
            display: none;
            white-space: nowrap;
        }

        &.active {
            background-color: var(--aqua-active);

            .product-btn__icon {     
                color: var(--base_black);
            }
        }

        &.open {
            background-color: var(--base_black);
            border: solid 1px var(--aqua-active);

            .product-btn__icon {
                color: var(--aqua-active)
            }
        }

        @include device-hoverable{
            &:hover {
                background-color: var(--base_black);
                border: solid 1px var(--aqua-active);

                .product-btn__icon {
                    color: var(--aqua-active)
                }
                .product-btn__text {
                    display: block;
                }
            }
        }
    }

    .btn-notice__content {
        --color: #454d66;
        position: absolute;
        z-index: 1;
        top: -15px;
        right: calc(100% + 30px);
        width: 220px;
        padding: 20px;
        text-align: center;
        font-size: 1rem;
        letter-spacing: 2px;
        border-radius: 10px;
        color: #fff;
        background: var(--color);

        &::before {
            content: '';
            position: absolute;
            left: 100%;
            top: 15px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 15px 0 15px 30px;
            border-color: transparent transparent transparent var(--color);
        }
    }

    .btn-notice__btn {
        margin: 10px 0 0 0;
        padding: 5px 10px;
        border-radius: 5px;
        font-weight: bold;
        background: var(--aqua-active);
        color: var(--base-dark-blue);

        &:hover {
            color: var(--aqua-active);
            background: var(--base-dark-blue);
        }
    }
</style>
